import { render } from "./PledgeCoin.vue?vue&type=template&id=b409b626&scoped=true"
import script from "./PledgeCoin.vue?vue&type=script&lang=js"
export * from "./PledgeCoin.vue?vue&type=script&lang=js"

import "./PledgeCoin.vue?vue&type=style&index=0&id=b409b626&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b409b626"]])

export default __exports__